import { Container } from 'react-bootstrap';
import './assets/css/style.scss';
import Slider from '../../SliderMain/Slider';
import RegisterModal from '../../RegisterModal/RegisterModal';
import React, { useState } from 'react';
// import ReactPlayer from 'react-player';

function Main() {
  const [showRegister, setShowRegister] = useState(false);
  // const [showVideo, setShowVideo] = useState(false);
  // const handleClose = () => setShowVideo(false);
  // const handleShow = () => setShowVideo(true);

  return (
    <div className="section main">
      <Container>
        <div className="main__content" id={"kushjemi"}>
          <h3>Shkollë Filozofie që promovon kulturën & praktikon vullnetarizmin</h3>
          <div className="main__content-buttons">
            <button onClick={() => setShowRegister(true)} className="button button--primary">
              <span>Regjistrohu Tani</span>
            </button>

            {/* <div className="video" onClick={handleShow} style={{ cursor: 'pointer' }}>
              <span className="video__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="21"
                  viewBox="0 0 15 21"
                  fill="none"
                >
                  <path
                    d="M13.871 9.71006C14.5445 10.195 14.5445 11.1975 13.871 11.6824L1.97601 20.2468C1.17219 20.8255 0.0507813 20.2511 0.0507813 19.2606L0.0507819 2.13186C0.050782 1.14136 1.17219 0.566934 1.97601 1.14569L13.871 9.71006Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              <span className="video__text">Njihu me Akropolin e Ri</span>
            </div> */}
          </div>
        </div>
      </Container>
      <Slider />

      {showRegister && <RegisterModal show={showRegister} onHide={() => setShowRegister(false)} />}

      {/* <Modal show={showVideo} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <ReactPlayer
              src="https://www.youtube.com/watch?v=YOUR_VIDEO_ID"
              width="100%"
              height="100%"
              controls
              playing
            />
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
}

export default Main;
